

const Breadcrumbs = () => {
  return (
    <div>
    <main id='main'>
    <div className="profilebreadcrumbs d-flex align-items-center breadcrumbs-profile">
      <div className="container position-relative d-flex flex-column align-items-center" data-aos="fade"> 

      </div>
    </div>

    </main>
    </div>
  )
}

export default Breadcrumbs
